import { createSlice } from "@reduxjs/toolkit";
import { addMedia, editMedia, getMedia, getMediaList } from "../services/media-services";

const initialState = {
  medias: [],
  media: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const mediaSlice = createSlice({
  name: "media",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMediaList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getMediaList.fulfilled, (state, action) => {
        state.medias = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getMediaList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getMedia.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getMedia.fulfilled, (state, action) => {
        state.medias = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getMedia.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addMedia.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(addMedia.fulfilled, (state, action) => {
        state.medias = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addMedia.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editMedia.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(editMedia.fulfilled, (state, action) => {
        state.medias = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editMedia.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      });
      
      
  },
});
export const { resetSuccess, resetState, resetError } = mediaSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default mediaSlice.reducer;
